import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Chip,
  Typography
} from '@mui/material';

import { EntityLinksList } from '../shared/EntityLinksList';
import { setActiveSection, setActiveTab } from './Strategy/strategySlice';
import { useDispatch } from 'react-redux';

export default function EntityListComp(props) {
  const dispatch = useDispatch();
  const {
    entityData,
    entityName,
    userInfoMap,
    isEdit,
    apiUrl,
    commonProps,
    activeSection
  } = props;
  const { switchFromStrategyInfoTabCheck } = commonProps;

  return (
    <Box mt={3}>
      <Accordion
        id={entityName}
        sx={{
          border: 'none',
          boxShadow: 'none',
          '&::before': {
            display: 'none'
          }
        }}
      >
        <AccordionSummary {...(entityData?.length === 0 && { expandIcon: '' })}>
          <Box
            display="grid"
            gridTemplateColumns="1fr auto"
            alignItems="center"
            width="100%"
            columnGap={(theme) =>
              theme.fuel6Tokens.JddcSpacingSpaceBetweenSmallIconAndText
            }
          >
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="labelLarge">{entityName}</Typography>
              <Chip
                color="informational"
                variant="badge"
                label={entityData?.length || '0'}
                size="small"
              />
            </Box>
            {isEdit && (
              <Button
                variant="secondary"
                onClick={(e) => {
                  if (switchFromStrategyInfoTabCheck()) {
                    dispatch(setActiveTab(2));
                    dispatch(setActiveSection(activeSection));
                  } else e.stopPropagation();
                }}
              >
                Edit {entityName}
              </Button>
            )}
          </Box>
        </AccordionSummary>
        {entityData?.length > 0 && (
          <AccordionDetails>
            <EntityLinksList
              key={entityData}
              entityName={entityName}
              apiUrl={apiUrl}
              entityData={entityData}
              userInfoMap={userInfoMap}
              commonProps={commonProps}
              doNotShowPhaseTags={true}
            />
          </AccordionDetails>
        )}
      </Accordion>
    </Box>
  );
}
